import { render, staticRenderFns } from "./kpi.vue?vue&type=template&id=e810e33c&scoped=true&"
import script from "./kpi.vue?vue&type=script&lang=js&"
export * from "./kpi.vue?vue&type=script&lang=js&"
import style0 from "./kpi.vue?vue&type=style&index=0&id=e810e33c&lang=scss&scoped=true&"
import style1 from "./kpi.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e810e33c",
  null
  
)

export default component.exports